<div class="page-section footer" [ngClass]="{ haptic: this.config.modalities[0].active }">

  <div class="footer-title">Contact me</div>
  <div class="address" (click)="loadPage(this.contact_info?.address_link)">{{ this.contact_info?.address }}</div>
  <div class="email buttonEl" (click)="linkTo('mailto:' + this.contact_info?.email)">{{ this.contact_info?.email }}</div>
  <div class="social-media">
    <ul class="social-media-list footer-list">
      <li *ngFor="let item of this.contact_info?.social_media">
        <div class="social-media-icon" [ngClass]="{ hovereffect: this.config.modalities[1].active }" (click)="loadPage(item?.url)" [inlineSVG]="item.icon" alt="visit my {{ item.name }} profile"></div>
      </li>
    </ul>
  </div>
  <div class="copyright">{{ current_year }} &#169; {{ this.contact_info?.rights }}</div>
</div>

